module.exports = __webpack_public_path__ + "static/media/1-4-v-chrame-obetovala.7c58605c.jpg";